import { List } from "@mui/material";
import UbicacionCard from "../UbicacionCard";

const Ubicaciones = ({ubicaciones, onAsistencia}) => {
  return <List>
    {ubicaciones.map(ubicacion => <UbicacionCard {...ubicacion} onAsistencia={!!onAsistencia ? () => onAsistencia(ubicacion) : null} />)}
  </List>
}

export default Ubicaciones;